import application from '~/stimulus_application';
import { MarksmithController, ListContinuationController } from '@avo-hq/marksmith';

application.register('marksmith', MarksmithController);
application.register('list-continuation', ListContinuationController);
